import { render, staticRenderFns } from "./NoticeMngtDtl.vue?vue&type=template&id=8a863678&scoped=true"
import script from "./NoticeMngtDtl.vue?vue&type=script&lang=js"
export * from "./NoticeMngtDtl.vue?vue&type=script&lang=js"
import style0 from "./NoticeMngtDtl.vue?vue&type=style&index=0&id=8a863678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a863678",
  null
  
)

export default component.exports